import { realTimeScoring } from "projectSpecific/sports/dbActions/realtimeScoring";
import { useCallback, useContext } from "react";
import { ParentContext } from "../../../global/cnr/contexts/ParentContext";
import { _matchResultSourceTypes } from "./useMatchResults";

export const _matchSeasonalCollection = 'matches_seasonal'


export const useSportsRealtimeResults = () => {

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { mainRt } = app_state

  const { pathViews } = paps_state ?? {}

  const getRealtimeResults = useCallback(async (callback) => {
    try {
      const latestSeason = 2026;

      let realtimeResults = null;
      let matchDayResults = null;

      const maybeReturn = () => {
        if (realtimeResults !== null && matchDayResults !== null) {
          callback({
            realtime: realtimeResults || {},
            matchDay: matchDayResults || {},
          });
        }
      };

      realTimeScoring.getRealtimeScores(
        mainRt,
        _matchResultSourceTypes.realtime,
        true,
        pathViews,
        latestSeason,
        (r) => {
          realtimeResults = r || {};
          maybeReturn();
        }
      );

      realTimeScoring.getRealtimeScores(
        mainRt,
        _matchResultSourceTypes.matchDay,
        true,
        pathViews,
        latestSeason,
        (r) => {
          matchDayResults = r || {};
          maybeReturn();
        }
      );

    } catch (err) {
      console.error(`❌ Failed to fetch event data`, err);
    }
  }, []);

  return { getRealtimeResults };

}; 